import { render, staticRenderFns } from "./ModeOfPayments.vue?vue&type=template&id=7637b242&"
import script from "./ModeOfPayments.vue?vue&type=script&lang=js&"
export * from "./ModeOfPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports